<div [class.mobile]="isMobile()">
  <button class="exit-button" (click)="navExit.emit()">
    <i nz-icon nzType="icons:exit" class="svgIcon"></i>
  </button>

  <div class="content ultrasonic" [class.mobile]="isMobile()">
    <i nz-icon nzType="icons:ultrasound" class="svgIcon big-icon"></i>
    <h1>{{ i18n.langString("ultrasonic_check") }}</h1>

    <app-card class="app-card-check">
      <span class="black-coral-text check-font">
        {{ i18n.langString("perform_check") }}
      </span>
      <br />

      <div class="ga-toggle" [class.ga-toggle-readonly]="!ultraSonicChecked()">
        <label class="body-bold">
          {{ i18n.langString("ultrasonic_check_done") }}
        </label>
        <nz-switch
          [ngModel]="ultraSonicChecked()"
          (ngModelChange)="ultraSonicChecked.set($event)"
        ></nz-switch>
      </div>

      <div class="black-coral-text check-font">
        {{
          i18n.langString(
            ultraSonicChecked()
              ? "enter_data_based_on_ultrasonic_toggle"
              : "add_sensor_based_on_ultrasonic_toggle"
          )
        }}
      </div>
    </app-card>
    <div class="innercontent">
      <div class="input-area-wrapper-close align-left">
        <h2>{{ i18n.langString("decibel_rating") }}</h2>
        <span class="black-coral-text">
          {{ i18n.langString("decibel_rating_hint") }}
        </span>

        <nz-input-group [nzSuffix]="suffixIconDecibel">
          <input
            nz-input
            type="text"
            placeholder="00"
            [ngModel]="decibelRating()"
            (ngModelChange)="checkPattern($event, 'decibel')"
            (input)="onDecibelInput($event)"
            [readonly]="!ultraSonicChecked()"
            [disabled]="!ultraSonicChecked()"
            (focus)="showDecibelValidation.set(true)"
            (blur)="showDecibelValidation.set(false)"
          />
        </nz-input-group>

        @if (ultraSonicChecked() && showDecibelValidation()) {
          <div class="listHints">
            <div
              [class.greenListHint]="
                isInRange(decibelRating(), decibelMin, decibelMax)
              "
              [class.redListHint]="
                !isInRange(decibelRating(), decibelMin, decibelMax)
              "
            >
              <i
                nz-icon
                [nzType]="
                  isInRange(decibelRating(), decibelMin, decibelMax)
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("numbersbetween1and140Allowed") }}
            </div>

            <div
              [class.greenListHint]="isPositive(decibelRating())"
              [class.redListHint]="!isPositive(decibelRating())"
            >
              <i
                nz-icon
                [nzType]="
                  isPositive(decibelRating())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("postiveValuesAllowed") }}
            </div>

            <div
              [class.greenListHint]="isNotDecimal(decibelRating())"
              [class.redListHint]="!isNotDecimal(decibelRating())"
            >
              <i
                nz-icon
                [nzType]="
                  isNotDecimal(decibelRating())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("decimalNumbersNotAllowed") }}
            </div>
          </div>
        }
      </div>
    </div>
    <div class="innercontent">
      <div class="input-area-wrapper-close align-left">
        <h2>{{ i18n.langString("inlet_outlet_temperature") }}</h2>
        <span class="black-coral-text">
          {{ i18n.langString("inlet_outlet_temperature_desc") }}
        </span>

        <!-- INLET -->
        <label class="select-label ultrasonic-label">
          {{ i18n.langString("current_inlet_temp") }}
        </label>
        <nz-input-group [nzSuffix]="suffixIconTemperature">
          <input
            nz-input
            type="text"
            [ngModel]="inletTemperature()"
            (ngModelChange)="checkPattern($event, 'inlet')"
            [readonly]="!ultraSonicChecked()"
            [disabled]="!ultraSonicChecked()"
            (focus)="showInletValidation.set(true)"
            (blur)="showInletValidation.set(false)"
          />
        </nz-input-group>

        @if (ultraSonicChecked() && showInletValidation()) {
          <div class="listHints">
            <div
              [class.greenListHint]="isPositive(inletTemperature())"
              [class.redListHint]="!isPositive(inletTemperature())"
            >
              <i
                nz-icon
                [nzType]="
                  isPositive(inletTemperature())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("postiveValuesAllowed") }}
            </div>

            <div
              [class.greenListHint]="isNotDecimal(inletTemperature())"
              [class.redListHint]="!isNotDecimal(inletTemperature())"
            >
              <i
                nz-icon
                [nzType]="
                  isNotDecimal(inletTemperature())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("decimalNumbersNotAllowed") }}
            </div>
          </div>
        }

        <!-- OUTLET -->
        <label class="select-label ultrasonic-label">
          {{ i18n.langString("current_outlet_temp") }}
        </label>
        <nz-input-group [nzSuffix]="suffixIconTemperature">
          <input
            nz-input
            type="text"
            [ngModel]="outletTemperature()"
            (ngModelChange)="checkPattern($event, 'outlet')"
            [readonly]="!ultraSonicChecked()"
            [disabled]="!ultraSonicChecked()"
            (focus)="showOutletValidation.set(true)"
            (blur)="showOutletValidation.set(false)"
          />
        </nz-input-group>

        @if (ultraSonicChecked() && showOutletValidation()) {
          <div class="listHints">
            <div
              [class.greenListHint]="isPositive(outletTemperature())"
              [class.redListHint]="!isPositive(outletTemperature())"
            >
              <i
                nz-icon
                [nzType]="
                  isPositive(outletTemperature())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("postiveValuesAllowed") }}
            </div>

            <div
              [class.greenListHint]="isNotDecimal(outletTemperature())"
              [class.redListHint]="!isNotDecimal(outletTemperature())"
            >
              <i
                nz-icon
                [nzType]="
                  isNotDecimal(outletTemperature())
                    ? 'icons:done-full-circle'
                    : 'icons:false-alert'
                "
              ></i>
              {{ i18n.langString("decimalNumbersNotAllowed") }}
            </div>
          </div>
        }
      </div>
    </div>
    <div class="innercontent">
      <div class="input-area-wrapper-close align-left">
        <h2>{{ i18n.langString("add_note_optional") }}</h2>
        <span class="black-coral-text">
          {{ i18n.langString("add_note_optional_hint") }}
        </span>

        <textarea
          nz-input
          class="textbox-rounded"
          [ngModel]="ultrasonicCheckNote()"
          (ngModelChange)="ultrasonicCheckNote.set($event)"
          [nzAutosize]="{ minRows: 4 }"
          [readonly]="!ultraSonicChecked()"
          [disabled]="!ultraSonicChecked()"
        ></textarea>
      </div>
    </div>
  </div>
</div>

<app-footer [class.mobile]="isMobile()">
  <div class="footer-inner-wrapper">
    @if (!isMobile()) {
      <app-nav-button
        class="desktop"
        [svgIcon]="'icons:arrow-left'"
        (clickEvent)="navBack.emit()"
      >
        {{ i18n.langString("go_back") }}
      </app-nav-button>
    } @else {
      <app-nav-button
        class="mobile btn-not-wide"
        [svgIcon]="'icons:arrow-left'"
        [primary]="true"
        (clickEvent)="navBack.emit()"
      ></app-nav-button>
    }

    @if (!saving) {
      <app-nav-button
        class="mobileFlex1 ultrasonic"
        svgIcon="icons:save"
        [primary]="true"
        [disabled]="!isSensorComplete() && ultraSonicChecked()"
        (clickEvent)="emitNavContinue()"
        [style]="isMobile() ? 'margin-left: 16px; width: 100%;' : ''"
      >
        {{ i18n.langString("finish_sensor") }}
      </app-nav-button>
    } @else {
      <app-spinner></app-spinner>
    }
  </div>
</app-footer>

<!-- ================= SUFFIX ICONS ================= -->
<ng-template #suffixIconTemperature><span>°C</span></ng-template>
<ng-template #suffixIconDecibel><span>dB</span></ng-template>
